export const MAX_PARTICIPANTS = process.env.REACT_APP_MAX_PARTICIPANTS || 6;